// Filename: collections/activitys
define('collections/template/templates',[
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/api',
    // Pull in the Model module from above
    'models/template/template'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // services
    API,
    // model
    MTemplate
) {

    var CTemplates = Backbone.Collection.extend({
        model: MTemplate,
        url: API.url("templates/"),
        comparator: 'name'

    });

    return CTemplates;
});

